import React from 'react';
import { InputContainer } from '../../../../../../common/components/form/form.module';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';


export const StorePickupInfoComponent = ({ onInnerFormChange, pickupPoints}: any) => {

  return (
               <>
<AccordionContainer
    child={
      <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
          <InputContainer
          isDisabled
              label="Name"
              name="Name"
              onValueChange={(event: any) => {
                onInnerFormChange(
                  event.target.value,
                  'StorePickupPoints.Name',
                  pickupPoints?.StorePickupPoints
                )
              }}
              type="text"
              value={pickupPoints?.StorePickupPoints?.Name}
          />
       <InputContainer
       isDisabled
              label="Pickup Fee"
              name="Pickup Fee"
              onValueChange={(event: any) => {
                onInnerFormChange(
                  event.target.value,
                  'StorePickupPoints.PickupFee',
                  pickupPoints?.StorePickupPoints
                )
              }}
              type="number"
              value={pickupPoints?.StorePickupPoints?.PickupFee}
          />
      <InputContainer
      isDisabled
              label="Display Order"
              name="Display Order"
              onValueChange={(event: any) => {
                onInnerFormChange(
                  event.target.value,
                  'StorePickupPoints.DisplayOrder',
                  pickupPoints?.DisplayOrder
                )
              }}
              type="number"
              value={pickupPoints?.StorePickupPoints?.DisplayOrder}
          />
      <InputContainer
             isDisabled="selectedStore.PrimaryAddress.Id"
             label="Address1"
             name="Address1"
             onValueChange={(event: any) => {
               onInnerFormChange(
                 event.target.value,
                 'pickupPoints.PrimaryAddress.Address1',
                 pickupPoints?.PrimaryAddress
               )
             }}
             type="text"
             value={pickupPoints?.PrimaryAddress?.Address1}
         />
  <InputContainer
             isDisabled="selectedStore.PrimaryAddress.Id"
             label="Address2"
             name="Address2"
             onValueChange={(event: any) => {
               onInnerFormChange(
                 event.target.value,
                 'pickupPoints.PrimaryAddress.Address2',
                 pickupPoints?.PrimaryAddress
               )
             }}
             type="text"
             value={pickupPoints?.PrimaryAddress?.Address2}
         />
 <InputContainer
             isDisabled="selectedStore.PrimaryAddress.Id"
             label="Address2"
             name="Address2"
             onValueChange={(event: any) => {
               onInnerFormChange(
                 event.target.value,
                 'pickupPoints.PrimaryAddress.Address2',
                 pickupPoints?.PrimaryAddress
               )
             }}
             type="text"
             value={pickupPoints?.PrimaryAddress?.Address2}
         />
<InputContainer
             isDisabled="selectedStore.PrimaryAddress.Id"
             label="Country"
             name="Country"
             onValueChange={(event: any) => {
               onInnerFormChange(
                 event.target.value,
                 'pickupPoints.PrimaryAddress.Country.Name',
                 pickupPoints?.PrimaryAddress?.Country
               )
             }}
             type="text"
             value={pickupPoints?.PrimaryAddress?.Country?.Name}
         />
   <InputContainer
             isDisabled="selectedStore.PrimaryAddress.Id"
             label="StateProvince"
             name="StateProvince"
             onValueChange={(event: any) => {
               onInnerFormChange(
                 event.target.value,
                 'pickupPoints.PrimaryAddress.StateProvince.Name',
                 pickupPoints?.PrimaryAddress?.StateProvince
               )
             }}
             type="text"
             value={pickupPoints?.PrimaryAddress?.StateProvince?.Name}
         />
<InputContainer
             isDisabled="selectedStore.PrimaryAddress.Id"
             label="City"
             name="City"
             onValueChange={(event: any) => {
               onInnerFormChange(
                 event.target.value,
                 'pickupPoints.PrimaryAddress.City',
                 pickupPoints?.PrimaryAddress?.City
               )
             }}
             type="text"
             value={pickupPoints?.PrimaryAddress?.City}
         />
 <InputContainer
             isDisabled="selectedStore.PrimaryAddress.Id"
             label="CountryCode"
             name="CountryCode"
             onValueChange={(event: any) => {
               onInnerFormChange(
                 event.target.value,
                 'pickupPoints.PrimaryAddress.CountryCode',
                 pickupPoints?.PrimaryAddress?.CountryCode
               )
             }}
             type="text"
             value={pickupPoints?.PrimaryAddress?.CountryCode}
         />
 <InputContainer
             isDisabled="selectedStore.PrimaryAddress.Id"
             label="ZipPostalCode"
             name="ZipPostalCode"
             onValueChange={(event: any) => {
               onInnerFormChange(
                 event.target.value,
                 'pickupPoints.PrimaryAddress.ZipPostalCode',
                 pickupPoints?.PrimaryAddress?.ZipPostalCode
               )
             }}
             type="text"
             value={pickupPoints?.PrimaryAddress?.ZipPostalCode}
         />
         <div className='col-span-full'>
  <InputContainer
  isDisabled
              label="Description"
              name="Description"
              onValueChange={(event: any) => {
                onInnerFormChange(
                  event.target.value,
                  'StorePickupPoints.Description',
                  pickupPoints?.Description
                )
              }}
              type="text"
              value={pickupPoints?.Description}
          /></div>
      
   </div>
      }
      expandedPanel="Pickuppoint Info"
      headerTitle="Pickuppoint Info"
  />
</>
  )
}
export default StorePickupInfoComponent;
